export default {
  title: 'Zamówienia',
};
